"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { ProviderType } from "@/types/dataProvider";
export const PodiumProviderForm = _props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InstructionsWrapper title="Connect Podium with OAuth:"><ol><li>Click Connect to open Podium's authorization screen.</li><li>Approve the requested access in Podium.</li><li>You'll return here once the connection is verified.</li></ol></InstructionsWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
(PodiumProviderForm as unknown as {
  providerType?: string;
}).providerType = ProviderType.PODIUM;